import { Space } from "types/generated";

import { INTERACTIVE_ATTRIBUTE_FOR_DRAWER } from "../constants";

export const getDefaultValues = (isEditMode: boolean, space?: Space) =>
  isEditMode
    ? {
        name: space?.name || "",
        description: space?.description || "",
        inheritEntities: !!space?.inheritEntities,
        parentSpace: space?.parentSpace || "",
        labels: space?.labels.map((value) => ({ value })) || [],
      }
    : {
        name: "",
        description: "",
        inheritEntities: true,
        parentSpace: space?.id,
        labels: [],
      };

export const isOnOutsideClickElementInteractive = (el: Element) => {
  // Treats modals as inside elements. This allows interactions with confirmation modals.
  if (el.closest("[data-modal]")) {
    return false;
  }

  // Portalled popovers (node ellipsis menu, SpaceSelect listbox, etc.) are outside `[data-modal]`
  // in the DOM but are not "click outside to dismiss" targets.
  if (
    el.closest('[role="menu"]') ||
    el.closest('[role="listbox"]') ||
    el.closest('[role="option"]')
  ) {
    return false;
  }

  const dataTreeInteractiveElements = document.querySelectorAll(
    `[${INTERACTIVE_ATTRIBUTE_FOR_DRAWER}]`
  );

  if (Array.from(dataTreeInteractiveElements).find((parent) => parent.contains(el))) {
    return false;
  }

  // TODO: refactor this approach
  const hrefElem =
    el.getAttribute("href") ||
    el.parentElement?.getAttribute("href") ||
    el.parentElement?.parentElement?.getAttribute("href");
  if (hrefElem?.includes("/spaces/") || hrefElem?.includes("/spaces?")) {
    return false;
  }

  return true;
};
